/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const PixMo = ({ color = 'primary', aspectRatio = '690/130', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="PixMo" aspectRatio={aspectRatio} color={color} {...rest} />;

export { PixMo, PixMo as default };
